// src/features/template/components/AllowedDomains.tsx
import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  styled
} from '@mui/material';
import { ALLOWED_DOMAINS } from '../constants';

const StyledSelect = styled(Select)(() => ({
  '& .MuiSelect-select': {
    paddingTop: '12px',
    paddingBottom: '12px',
    minHeight: '25px !important',
  },
  '& .MuiSelect-multiple': {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
  },
  '& .MuiMenuItem-root': {
    padding: '12px 16px',
  }
}));

interface Props {
  selectedDomains: string[];
  onChange: (domains: string[]) => void;
  error?: string;
}

export const AllowedDomains: React.FC<Props> = ({ selectedDomains, onChange, error }) => {
  return (
    <FormControl fullWidth sx={{ mb: 4 }}>
      <InputLabel sx={{ 
        color: 'rgba(255, 255, 255, 0.7)',
        '&.Mui-focused': {
          color: '#00A4E0'
        },
        '&.MuiInputLabel-shrink': {
          background: 'linear-gradient(to bottom, transparent 0%, #243B53 45%, #243B53 100%)',
          paddingRight: '8px',
          paddingLeft: '8px',
          marginTop: '1px'
        }
      }}>
        Allowed Domains
      </InputLabel>
      <StyledSelect
        multiple
        value={selectedDomains}
        onChange={(e) => onChange(e.target.value as string[])}
        error={!!error}
        renderValue={(selected: unknown) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {(selected as string[]).map((value) => (
              <Box
                key={value}
                sx={{
                  backgroundColor: 'rgba(255, 255, 255, 0.08)',
                  borderRadius: '4px',
                  px: 1,
                  py: 0.5,
                  fontSize: '0.875rem'
                }}
              >
                {value}
              </Box>
            ))}
          </Box>
        )}
        sx={{ 
          backgroundColor: '#1B2B3A',
          borderRadius: '8px',
          color: 'white',
          '& fieldset': {
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '8px'
          },
          '&:hover fieldset': {
            borderColor: 'rgba(255, 255, 255, 0.3)'
          },
          '&.Mui-focused fieldset': {
            borderColor: '#00A4E0'
          },
          '& .MuiSelect-icon': {
            color: 'rgba(255, 255, 255, 0.7)'
          }
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              bgcolor: '#1B2B3A',
              maxHeight: 300,
              '& .MuiMenuItem-root': {
                padding: '8px 16px',
                color: 'white',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.08)'
                },
                '&.Mui-selected': {
                  backgroundColor: 'rgba(0, 164, 224, 0.15)',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 164, 224, 0.25)'
                  }
                }
              }
            }
          }
        }}
      >
        {ALLOWED_DOMAINS.map(domain => (
          <MenuItem key={domain} value={domain}>
            {domain}
          </MenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
};
